import React, { useState } from "react";
import styles from "./Overview.module.css";
import { TextComponent } from "../../../../../components";
import { List, Table } from "antd";
import { t } from "i18next";
import HeadingComponent from "../../../../../components/HeadingComponent/HeadingComponent";

const TabsOverview = () => {

    const ProcessDetails = [
        {
            id: 1,
            title: "Process Code",
            title_2: "MAT-001",
        },
        {
            id: 2,
            title: "Process Name",
            title_2: "Flour Dough",
        },
        {
            id: 3,
            title: "Station",
            title_2: "Mixing",
        },
        {
            id: 4,
            title: "Linked Recipes",
            title_2: "69",
        },
    ];
    const FinishedProcessParameters = [
        {
            id: 1,
            title: "Bake Temperature (Fahrenheit)",
            title_2: "Numeric",
        },
        {
            id: 2,
            title: "Time (minutes)",
            title_2: "Numeric",
        },
        
    ];
    return (
        <div className={styles.mainCon}>
            <TextComponent className={styles.Heading} text={"Process Details"} />
            <div className={styles.Box}>
                {ProcessDetails.map((item, index) => {
                    return (
                        <div key={item?.id} className={styles.ItemDiv}>
                            <TextComponent
                                text={item.title}
                                className={styles.SubHeading}
                            />
                            <TextComponent
                                text={item.title_2}
                                className={styles.Card_Text}
                            />
                        </div>
                    );
                })}
            </div>
           
            <TextComponent className={styles.Heading} text={"Finished Process Parameters"} />
            <div className={styles.Box}>
                {FinishedProcessParameters.map((item, index) => {
                    return (
                        <div key={item?.id} className={styles.ItemDiv}>
                            <TextComponent
                                text={item.title}
                                className={styles.SubHeading}
                            />
                            <TextComponent
                                text={item.title_2}
                                className={styles.Card_Text}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TabsOverview;
